import { Box, Alert, AlertTitle } from "@mui/material";
import { WarningAmber } from "@mui/icons-material";
import localize from "../../common/localize";

// Shown when a user without ACCESS to a module reaches it (e.g. via direct URL).
export default function UnauthorizedModule() {
  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 90px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
      }}
    >
      <Alert
        severity="warning"
        icon={<WarningAmber fontSize="inherit" />}
        sx={{
          maxWidth: 520,
          width: "100%",
          alignItems: "center",
          boxShadow:
            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
        }}
      >
        <AlertTitle sx={{ fontWeight: 700 }}>
          {localize.module_access_denied_title}
        </AlertTitle>
        <span className="text-sm">{localize.module_access_denied}</span>
      </Alert>
    </Box>
  );
}
